import { Badge } from '../../../components/ui/Badge.js';

interface Job {
  readonly machine: string;
  readonly name: string;
  readonly eta: string;
  readonly status: 'on_track' | 'at_risk' | 'blocked';
}

const MOCK_JOBS: readonly Job[] = [
  { machine: 'FANUC-01', name: 'PN-4827 housing', eta: '2h 14m', status: 'on_track' },
  { machine: 'MAZAK-03', name: 'PN-9912 bracket', eta: '4h 02m', status: 'at_risk' },
  { machine: 'HAAS-02', name: 'PN-7733 spacer', eta: '38m', status: 'on_track' },
  { machine: 'OKUMA-01', name: 'PN-1041 mount', eta: 'blocked', status: 'blocked' },
];

const STATUS_LABEL: Record<Job['status'], string> = {
  on_track: 'On track',
  at_risk: 'At risk',
  blocked: 'Blocked',
};

const STATUS_TONE: Record<Job['status'], 'opportunity' | 'warning' | 'critical'> = {
  on_track: 'opportunity',
  at_risk: 'warning',
  blocked: 'critical',
};

export function SchedulePanel(): JSX.Element {
  return (
    <section className="rounded-md border border-border bg-card overflow-hidden">
      <header className="px-4 py-3 border-b border-border flex items-center justify-between">
        <h2 className="font-mono text-xs uppercase tracking-[0.2em] text-text-dim">
          Schedule — Today
        </h2>
      </header>
      <ul>
        {MOCK_JOBS.map((job) => (
          <li
            key={`${job.machine}-${job.name}`}
            className="border-t border-border first:border-t-0 px-4 py-3 flex items-center gap-3"
          >
            <span
              className="font-mono text-[10px] uppercase tracking-[0.2em] px-1.5 py-1 rounded-sm border border-border text-text-dim"
              style={{ backgroundColor: 'rgba(139,163,184,0.06)' }}
            >
              {job.machine}
            </span>
            <span className="flex-1 text-sm">{job.name}</span>
            <span className="text-[11px] font-mono text-text-dim">{job.eta}</span>
            <Badge tone={STATUS_TONE[job.status]}>{STATUS_LABEL[job.status]}</Badge>
          </li>
        ))}
      </ul>
      <p className="px-4 py-2 text-[10px] font-mono text-muted border-t border-border">
        Mock data · scheduling lands in v1.1.
      </p>
    </section>
  );
}
